import GRAND_FINALE_QUIZ_BACKGROUND_IMAGE from '../../../assets/images/club/quiz/PROTECTED-grand-final-quiz-background.webp';
import QUIZ_CIRQULAR_PROGRAMME_BACKGROUND_IMAGE from '../../../assets/images/club/quiz/quiz-cirqular-programme-background.webp';
import QUIZ_START_BACKGROUND from '../../../assets/images/club/quiz/quiz-start-background.webp';
import QUIZ_START_IMAGE from '../../../assets/images/club/quiz/quiz-start-image.webp';
import SWITCH_START_IMAGE from '../../../assets/images/club/switch-program/PROTECTED-start.webp';
import AlwaysReadyIcon from '../../../components/Icons/ClubPage/AlwaysReadyIcon';
import ContestsIcon from '../../../components/Icons/ClubPage/ContestsIcon';
import CompletedIcon from '../../../components/Icons/ClubSwitch/CompletedIcon';
import InfoIcon from '../../../components/Icons/ClubSwitch/InfoIcon';
import badgeTypes from '../../../consts/loyalty/badgeTypes';
import milestoneTypes from '../../../consts/loyalty/milestoneTypes';
import quizQuestionTypes from '../../../consts/loyalty/quizQuestionTypes';
import quizTypes from '../../../consts/loyalty/quizTypes';
import userSegmentTypes from '../../../consts/loyalty/userSegmentTypes';
import userSurveyAnswerTypes from '../../../consts/loyalty/userSurveyAnswerTypes';
import userSurveyTypes from '../../../consts/loyalty/userSurveyTypes';
import {MODAL_TYPES} from '../../../consts/modal/modalTypes';
import routes from '../../../consts/routes';
import {strCode} from '../../../consts/strCode';
import loyaltyService from '../../../services/loyalty/loyaltyService';
import routerService from '../../../services/router/routerService';
import {resetQuiz, setCurrentBadge, startQuiz} from '../../../state/slice/loyalty';
import {hideAllModals, hideModal, showStoresModal} from '../../../state/slice/modal';
import {dispatch} from '../../../state/store';
import ClubPageReportQuizFirstSlide from '../ClubPageReport/ClubPageReportQuizFirstSlide';

const CLUB_QUIZ_CONFIG = {
    [quizTypes.SWITCH_PROGRAM_QUIZ]: {
        startImage: SWITCH_START_IMAGE,
        preTitleStrCode: strCode.CLUB_SWITCH_PROGRAM_QUIZ_PRE_TITLE,
        titleStrCode: strCode.CLUB_SWITCH_PROGRAM_QUIZ_TITLE,
        descriptionStrCode: strCode.CLUB_SWITCH_PROGRAM_QUIZ_DESCRIPTION,
        buttonStrCode: strCode.CLUB_SWITCH_PROGRAM_QUIZ_BUTTON,
        showValidation: false,
        slides: [
            {
                id: userSurveyTypes.SOURCING,
                titleStrCode: strCode.CLUB_SWITCH_PROGRAM_QUIZ_SLIDE_1_TITLE,
                options: [
                    {
                        id: userSurveyAnswerTypes.SOURCING_CC,
                        titleStrCode: strCode.CLUB_SWITCH_PROGRAM_QUIZ_SLIDE_1_ANSWER_1,
                        isCorrect: true,
                    },
                    {
                        id: userSurveyAnswerTypes.SOURCING_EVAPOR,
                        titleStrCode: strCode.CLUB_SWITCH_PROGRAM_QUIZ_SLIDE_1_ANSWER_2,
                        isCorrect: true,
                    },
                    {
                        id: userSurveyAnswerTypes.SOURCING_COMP_HNB,
                        titleStrCode: strCode.CLUB_SWITCH_PROGRAM_QUIZ_SLIDE_1_ANSWER_3,
                        isCorrect: true,
                    },
                    {
                        id: userSurveyAnswerTypes.SOURCING_POUCHES,
                        titleStrCode: strCode.CLUB_SWITCH_PROGRAM_QUIZ_SLIDE_1_ANSWER_4,
                        isCorrect: true,
                    },
                ],
            },
            {
                id: userSurveyTypes.MOTIVATION,
                titleStrCode: strCode.CLUB_SWITCH_PROGRAM_QUIZ_SLIDE_2_TITLE,
                options: [
                    {
                        id: userSurveyAnswerTypes.MOTIVATION_HIGH,
                        titleStrCode: strCode.CLUB_SWITCH_PROGRAM_QUIZ_SLIDE_2_ANSWER_1,
                    },
                    {
                        id: userSurveyAnswerTypes.MOTIVATION_MID,
                        titleStrCode: strCode.CLUB_SWITCH_PROGRAM_QUIZ_SLIDE_2_ANSWER_2,
                    },
                    {
                        id: userSurveyAnswerTypes.MOTIVATION_LOW,
                        titleStrCode: strCode.CLUB_SWITCH_PROGRAM_QUIZ_SLIDE_2_ANSWER_3,
                    },
                ],
            },
            {
                id: userSurveyTypes.REASON,
                titleStrCode: strCode.CLUB_SWITCH_PROGRAM_QUIZ_SLIDE_3_TITLE,
                onConversionClick: async () => {
                    return await loyaltyService.updateConversionData();
                },
                onReturnBtnClick: async () => {
                    await loyaltyService.saveConversionQuizData();
                    dispatch(hideAllModals());
                },
                options: [
                    {
                        id: userSurveyAnswerTypes.REASON_SOCIAL,
                        titleStrCode: strCode.CLUB_SWITCH_PROGRAM_QUIZ_SLIDE_3_ANSWER_1,
                    },
                    {
                        id: userSurveyAnswerTypes.REASON_TASTE,
                        titleStrCode: strCode.CLUB_SWITCH_PROGRAM_QUIZ_SLIDE_3_ANSWER_2,
                    },
                    {
                        id: userSurveyAnswerTypes.REASON_AESTHETIC,
                        titleStrCode: strCode.CLUB_SWITCH_PROGRAM_QUIZ_SLIDE_3_ANSWER_3,
                    },
                ],
            },
        ],
        notCompletedSlide: {
            icon: InfoIcon,
            titleStrCode: strCode.CLUB_SWITCH_PROGRAM_QUIZ_THANK_TITLE,
            descriptionStrCode: strCode.CLUB_SWITCH_PROGRAM_QUIZ_THANK_DESCRIPTION,
            buttonStrCode: strCode.CLUB_SWITCH_PROGRAM_QUIZ_THANK_ACCEPT,
            isDefaultNavigation: true,
            routeTo: routes.HOME,
            onClick: () => {
                dispatch(hideAllModals());
            },
            declineButtonStrCode: strCode.CLUB_SWITCH_PROGRAM_QUIZ_THANK_DECLINE,
            onDeclineClick: () => {
                dispatch(resetQuiz(quizTypes.SWITCH_PROGRAM_QUIZ));
                dispatch(startQuiz(quizTypes.SWITCH_PROGRAM_QUIZ));
            },
        },
        completedSlide: {
            icon: CompletedIcon,
            titleStrCode: strCode.CLUB_SWITCH_PROGRAM_QUIZ_WELCOME_TITLE,
            buttonStrCode: strCode.CLUB_SWITCH_PROGRAM_QUIZ_WELCOME_BUTTON,
            routeTo: routes.CLUB_BADGE,
            onClick: () => {
                dispatch(hideAllModals());
                dispatch(setCurrentBadge(badgeTypes.SWITCH_MASTER));
            },
        },
    },
    [quizTypes.QUEST_CHAMPION_QUIZ]: {
        titleStrCode: strCode.CLUB_IQOS_EXPERT_QUIZ_TITLE,
        descriptionStrCode: strCode.CLUB_IQOS_EXPERT_QUIZ_DESCRIPTION,
        buttonStrCode: strCode.CLUB_IQOS_EXPERT_QUIZ_BUTTON,
        badge: badgeTypes.IQOS_EXPERT,
        startBackground: QUIZ_START_BACKGROUND,
        startImage: QUIZ_START_IMAGE,
        milestoneType: milestoneTypes.QUEST_CHAMPION_QUIZ,
        showValidation: true,
        slides: [
            {
                id: 0,
                titleStrCode: strCode.CLUB_IQOS_EXPERT_QUIZ_SLIDE_1_TITLE,
                options: [
                    {id: '1_1', titleStrCode: strCode.CLUB_IQOS_EXPERT_QUIZ_SLIDE_1_ANSWER_1},
                    {id: '1_2', titleStrCode: strCode.CLUB_IQOS_EXPERT_QUIZ_SLIDE_1_ANSWER_2, isCorrect: true},
                    {id: '1_3', titleStrCode: strCode.CLUB_IQOS_EXPERT_QUIZ_SLIDE_1_ANSWER_3, isCorrect: true},
                ],
            },
            {
                id: 1,
                titleStrCode: strCode.CLUB_IQOS_EXPERT_QUIZ_SLIDE_2_TITLE,
                options: [
                    {id: '2_1', titleStrCode: strCode.CLUB_IQOS_EXPERT_QUIZ_SLIDE_2_ANSWER_1},
                    {id: '2_2', titleStrCode: strCode.CLUB_IQOS_EXPERT_QUIZ_SLIDE_2_ANSWER_2, isCorrect: true},
                    {id: '2_3', titleStrCode: strCode.CLUB_IQOS_EXPERT_QUIZ_SLIDE_2_ANSWER_3},
                ],
            },
            {
                id: 2,
                titleStrCode: strCode.CLUB_IQOS_EXPERT_QUIZ_SLIDE_3_TITLE,
                options: [
                    {id: '3_1', titleStrCode: strCode.CLUB_IQOS_EXPERT_QUIZ_SLIDE_3_ANSWER_1, isCorrect: true},
                    {id: '3_2', titleStrCode: strCode.CLUB_IQOS_EXPERT_QUIZ_SLIDE_3_ANSWER_2},
                    {id: '3_3', titleStrCode: strCode.CLUB_IQOS_EXPERT_QUIZ_SLIDE_3_ANSWER_3, isCorrect: true},
                ],
            },
        ],
        // notCompletedSlide: {
        //     titleStrCode: strCode.CLUB_IQOS_EXPERT_QUIZ_NOT_COMPLETE_TITLE,
        //     descriptionStrCode: strCode.CLUB_IQOS_EXPERT_QUIZ_NOT_COMPLETE_DESCRIPTION,
        //     buttonStrCode: strCode.CLUB_IQOS_EXPERT_QUIZ_NOT_COMPLETE_BUTTON,
        //     onClick: () => dispatch(resetQuiz(quizTypes.QUEST_CHAMPION_QUIZ)),
        //     declineButtonStrCode: strCode.CLUB_IQOS_EXPERT_QUIZ_NOT_COMPLETE_DECLINE_BUTTON,
        // },
        completedSlide: {
            titleStrCode: strCode.CLUB_IQOS_EXPERT_QUIZ_COMPLETE_TITLE,
            buttonStrCode: strCode.CLUB_IQOS_EXPERT_QUIZ_COMPLETE_BUTTON,
            onClick: () => dispatch(hideAllModals()),
        },
    },
    [quizTypes.IQOS_EXPERT_QUIZ]: {
        titleStrCode: strCode.CLUB_IQOS_EXPERT_QUIZ_TITLE,
        descriptionStrCode: strCode.CLUB_IQOS_EXPERT_QUIZ_DESCRIPTION,
        buttonStrCode: strCode.CLUB_IQOS_EXPERT_QUIZ_BUTTON,
        badge: badgeTypes.IQOS_EXPERT,
        startBackground: QUIZ_START_BACKGROUND,
        startImage: QUIZ_START_IMAGE,
        milestoneType: milestoneTypes.IQOS_EXPERT_QUIZ,
        showValidation: true,
        slides: [
            {
                id: 0,
                titleStrCode: strCode.CLUB_IQOS_EXPERT_QUIZ_SLIDE_1_TITLE,
                options: [
                    {id: '1_1', titleStrCode: strCode.CLUB_IQOS_EXPERT_QUIZ_SLIDE_1_ANSWER_1},
                    {id: '1_2', titleStrCode: strCode.CLUB_IQOS_EXPERT_QUIZ_SLIDE_1_ANSWER_2, isCorrect: true},
                    {id: '1_3', titleStrCode: strCode.CLUB_IQOS_EXPERT_QUIZ_SLIDE_1_ANSWER_3, isCorrect: true},
                ],
            },
            {
                id: 1,
                titleStrCode: strCode.CLUB_IQOS_EXPERT_QUIZ_SLIDE_2_TITLE,
                options: [
                    {id: '2_1', titleStrCode: strCode.CLUB_IQOS_EXPERT_QUIZ_SLIDE_2_ANSWER_1},
                    {id: '2_2', titleStrCode: strCode.CLUB_IQOS_EXPERT_QUIZ_SLIDE_2_ANSWER_2, isCorrect: true},
                    {id: '2_3', titleStrCode: strCode.CLUB_IQOS_EXPERT_QUIZ_SLIDE_2_ANSWER_3},
                ],
            },
            {
                id: 2,
                titleStrCode: strCode.CLUB_IQOS_EXPERT_QUIZ_SLIDE_3_TITLE,
                options: [
                    {id: '3_1', titleStrCode: strCode.CLUB_IQOS_EXPERT_QUIZ_SLIDE_3_ANSWER_1, isCorrect: true},
                    {id: '3_2', titleStrCode: strCode.CLUB_IQOS_EXPERT_QUIZ_SLIDE_3_ANSWER_2},
                    {id: '3_3', titleStrCode: strCode.CLUB_IQOS_EXPERT_QUIZ_SLIDE_3_ANSWER_3, isCorrect: true},
                ],
            },
        ],
        // notCompletedSlide: {
        //     titleStrCode: strCode.CLUB_IQOS_EXPERT_QUIZ_NOT_COMPLETE_TITLE,
        //     descriptionStrCode: strCode.CLUB_IQOS_EXPERT_QUIZ_NOT_COMPLETE_DESCRIPTION,
        //     buttonStrCode: strCode.CLUB_IQOS_EXPERT_QUIZ_NOT_COMPLETE_BUTTON,
        //     onClick: () => dispatch(resetQuiz(quizTypes.IQOS_EXPERT_QUIZ)),
        //     declineButtonStrCode: strCode.CLUB_IQOS_EXPERT_QUIZ_NOT_COMPLETE_DECLINE_BUTTON,
        // },
        completedSlide: {
            titleStrCode: strCode.CLUB_IQOS_EXPERT_QUIZ_COMPLETE_TITLE,
            buttonStrCode: strCode.CLUB_IQOS_EXPERT_QUIZ_COMPLETE_BUTTON,
            onClick: () => dispatch(hideAllModals()),
        },
    },
    [quizTypes.REPORT_QUIZ]: {
        slides: [
            {
                id: 0,
                titleStrCode: strCode.CLUB_PAGE_REPORT_QUIZ_SLIDE_1_TITLE,
                confirmButtonStrCode: strCode.CLUB_PAGE_REPORT_QUIZ_SLIDE_1_BUTTON,
                slideComponent: ClubPageReportQuizFirstSlide,
            },
            {
                id: 1,
                titleStrCode: strCode.CLUB_PAGE_REPORT_QUIZ_SLIDE_2_TITLE,
                options: [
                    {id: '2_1', titleStrCode: strCode.CLUB_PAGE_REPORT_QUIZ_SLIDE_2_ANSWER_1, isCorrect: true},
                    {id: '2_2', titleStrCode: strCode.CLUB_PAGE_REPORT_QUIZ_SLIDE_2_ANSWER_2, isCorrect: true},
                    {id: '2_3', titleStrCode: strCode.CLUB_PAGE_REPORT_QUIZ_SLIDE_2_ANSWER_3, isCorrect: true},
                    {id: '2_4', titleStrCode: strCode.CLUB_PAGE_REPORT_QUIZ_SLIDE_2_ANSWER_4, isCorrect: true},
                ],
            },
        ],
    },
    [quizTypes.QUIZ_CIRQULAR_PROGRAMME]: {
        titleStrCode: strCode.CLUB_PAGE_QUIZ_CIRQULAR_PROGRAMME_TITLE,
        descriptionStrCode: strCode.CLUB_PAGE_QUIZ_CIRQULAR_PROGRAMME_DESCRIPTION,
        buttonStrCode: strCode.CLUB_PAGE_QUIZ_CIRQULAR_PROGRAMME_BUTTON,
        startBackground: QUIZ_CIRQULAR_PROGRAMME_BACKGROUND_IMAGE,
        milestoneType: milestoneTypes.SWITCH_34,
        badge: badgeTypes.SWITCH_MASTER,
        showValidation: true,
        slides: [
            {
                id: 0,
                type: quizQuestionTypes.FILL_BLANKS,
                titleStrCode: strCode.CLUB_PAGE_QUIZ_CIRQULAR_PROGRAMME_COMPLETE_SENTENCE,
                questionStrCode: strCode.CLUB_PAGE_QUIZ_CIRQULAR_PROGRAMME_Q1_QUESTION,
                blanks: [
                    {
                        id: 'blank1_1',
                        correctOptionId: '1_3',
                        placeholderStrCode: strCode.CLUB_PAGE_QUIZ_CIRQULAR_PROGRAMME_Q1_BLANK1_HINT,
                    },
                    {
                        id: 'blank1_2',
                        correctOptionId: '1_1',
                        placeholderStrCode: strCode.CLUB_PAGE_QUIZ_CIRQULAR_PROGRAMME_Q1_BLANK2_HINT,
                    },
                ],
                options: [
                    {
                        id: '1_1',
                        titleStrCode: strCode.CLUB_PAGE_QUIZ_CIRQULAR_PROGRAMME_Q1_OPTION_CIRCULAR_PROGRAMME,
                        blankId: 'blank1_2',
                        isCorrect: true,
                    },
                    {id: '1_2', titleStrCode: strCode.CLUB_PAGE_QUIZ_CIRQULAR_PROGRAMME_Q1_OPTION_WASTE_CENTER},
                    {
                        id: '1_3',
                        titleStrCode: strCode.CLUB_PAGE_QUIZ_CIRQULAR_PROGRAMME_Q1_OPTION_STICKS,
                        blankId: 'blank1_1',
                        isCorrect: true,
                    },
                    {id: '1_4', titleStrCode: strCode.CLUB_PAGE_QUIZ_CIRQULAR_PROGRAMME_Q1_OPTION_BUTTS},
                    {id: '1_5', titleStrCode: strCode.CLUB_PAGE_QUIZ_CIRQULAR_PROGRAMME_Q1_OPTION_BIN},
                ],
            },
            {
                id: 1,
                type: quizQuestionTypes.FILL_BLANKS,
                titleStrCode: strCode.CLUB_PAGE_QUIZ_CIRQULAR_PROGRAMME_COMPLETE_SENTENCE,
                questionStrCode: strCode.CLUB_PAGE_QUIZ_CIRQULAR_PROGRAMME_Q2_QUESTION,
                blanks: [
                    {
                        id: 'blank2_1',
                        placeholderStrCode: strCode.CLUB_PAGE_QUIZ_CIRQULAR_PROGRAMME_Q2_BLANK1_HINT,
                        correctOptionId: '2_1',
                    },
                    {
                        id: 'blank2_2',
                        placeholderStrCode: strCode.CLUB_PAGE_QUIZ_CIRQULAR_PROGRAMME_Q2_BLANK2_HINT,
                        correctOptionId: '2_2',
                    },
                ],
                options: [
                    {
                        id: '2_1',
                        titleStrCode: strCode.CLUB_PAGE_QUIZ_CIRQULAR_PROGRAMME_Q2_OPTION_STORE,
                        isCorrect: true,
                        blankId: 'blank2_1',
                    },
                    {
                        id: '2_2',
                        titleStrCode: strCode.CLUB_PAGE_QUIZ_CIRQULAR_PROGRAMME_Q2_OPTION_RECYCLE,
                        isCorrect: true,
                        blankId: 'blank2_2',
                    },
                    {
                        id: '2_3',
                        titleStrCode: strCode.CLUB_PAGE_QUIZ_CIRQULAR_PROGRAMME_Q2_OPTION_REPURPOSE,
                    },
                    {
                        id: '2_4',
                        titleStrCode: strCode.CLUB_PAGE_QUIZ_CIRQULAR_PROGRAMME_Q2_OPTION_SHOPPING,
                    },
                    {
                        id: '2_5',
                        titleStrCode: strCode.CLUB_PAGE_QUIZ_CIRQULAR_PROGRAMME_Q2_OPTION_REUSE,
                    },
                ],
            },
            {
                id: 2,
                type: quizQuestionTypes.FILL_BLANKS,
                titleStrCode: strCode.CLUB_PAGE_QUIZ_CIRQULAR_PROGRAMME_COMPLETE_SENTENCE,
                questionStrCode: strCode.CLUB_PAGE_QUIZ_CIRQULAR_PROGRAMME_Q3_QUESTION,
                blanks: [
                    {
                        id: 'blank3_1',
                        placeholderStrCode: strCode.CLUB_PAGE_QUIZ_CIRQULAR_PROGRAMME_Q3_BLANK1_HINT,
                        correctOptionId: '3_2',
                    },
                    {
                        id: 'blank3_2',
                        placeholderStrCode: strCode.CLUB_PAGE_QUIZ_CIRQULAR_PROGRAMME_Q3_BLANK2_HINT,
                        correctOptionId: '3_3',
                    },
                ],
                options: [
                    {
                        id: '3_1',
                        titleStrCode: strCode.CLUB_PAGE_QUIZ_CIRQULAR_PROGRAMME_Q3_OPTION_GLASS,
                    },
                    {
                        id: '3_2',
                        titleStrCode: strCode.CLUB_PAGE_QUIZ_CIRQULAR_PROGRAMME_Q3_OPTION_PAPER,
                        isCorrect: true,
                        blankId: 'blank3_1',
                    },
                    {
                        id: '3_3',
                        titleStrCode: strCode.CLUB_PAGE_QUIZ_CIRQULAR_PROGRAMME_Q3_OPTION_PLASTIC,
                        isCorrect: true,
                        blankId: 'blank3_2',
                    },
                    {
                        id: '3_4',
                        titleStrCode: strCode.CLUB_PAGE_QUIZ_CIRQULAR_PROGRAMME_Q3_OPTION_ALUMINIUM,
                    },
                    {
                        id: '3_5',
                        titleStrCode: strCode.CLUB_PAGE_QUIZ_CIRQULAR_PROGRAMME_Q3_OPTION_FABRIC,
                    },
                ],
            },
        ],
        completedSlide: {
            titleStrCode: strCode.CLUB_PAGE_QUIZ_CIRQULAR_PROGRAMME_COMPLETE_TITLE,
            buttonStrCode: strCode.CLUB_PAGE_QUIZ_CIRQULAR_PROGRAMME_COMPLETE_BUTTON,
            milestoneTitleStrCode: strCode.CLUB_PAGE_QUIZ_CIRQULAR_PROGRAMME_COMPLETE_MILESTONE_TITLE,
            onClick: () => dispatch(hideModal(MODAL_TYPES.CLUB_PAGE_QUIZ_MODAL)),
        },
    },
    [quizTypes.GRAND_FINALE_QUIZ]: {
        titleStrCode: strCode.CLUB_GRAND_FINALE_QUIZ_TITLE,
        descriptionStrCode: strCode.CLUB_GRAND_FINALE_QUIZ_DESCRIPTION,
        buttonStrCode: strCode.CLUB_GRAND_FINALE_QUIZ_BUTTON,
        badge: badgeTypes.SWITCH_MASTER,
        startBackground: GRAND_FINALE_QUIZ_BACKGROUND_IMAGE,
        milestoneType: milestoneTypes.SWITCH_35,
        showValidation: true,
        slides: [
            {
                id: 1,
                titleStrCode: strCode.CLUB_GRAND_FINALE_QUIZ_SLIDE_1_TITLE,
                options: [
                    {id: '1_1', titleStrCode: strCode.CLUB_GRAND_FINALE_QUIZ_Q1_ANSWER_1},
                    {id: '1_2', titleStrCode: strCode.CLUB_GRAND_FINALE_QUIZ_Q1_ANSWER_2},
                    {id: '1_3', titleStrCode: strCode.CLUB_GRAND_FINALE_QUIZ_Q1_ANSWER_3},
                    {id: '1_4', titleStrCode: strCode.CLUB_GRAND_FINALE_QUIZ_Q1_ANSWER_4, isCorrect: true},
                ],
            },
            {
                id: 2,
                titleStrCode: strCode.CLUB_GRAND_FINALE_QUIZ_SLIDE_2_REGULAR_TITLE,
                options: [
                    {id: '2_1', titleStrCode: strCode.CLUB_GRAND_FINALE_QUIZ_Q2_REGULAR_ANSWER_1},
                    {id: '2_2', titleStrCode: strCode.CLUB_GRAND_FINALE_QUIZ_Q2_REGULAR_ANSWER_2},
                    {id: '2_3', titleStrCode: strCode.CLUB_GRAND_FINALE_QUIZ_Q2_REGULAR_ANSWER_3, isCorrect: true},
                    {id: '2_4', titleStrCode: strCode.CLUB_GRAND_FINALE_QUIZ_Q2_REGULAR_ANSWER_4},
                ],
                [userSegmentTypes.MILD]: {
                    titleStrCode: strCode.CLUB_GRAND_FINALE_QUIZ_SLIDE_2_MILD_TITLE,
                    options: [
                        {id: '2_1', titleStrCode: strCode.CLUB_GRAND_FINALE_QUIZ_Q2_MILD_ANSWER_1},
                        {id: '2_2', titleStrCode: strCode.CLUB_GRAND_FINALE_QUIZ_Q2_MILD_ANSWER_2},
                        {id: '2_3', titleStrCode: strCode.CLUB_GRAND_FINALE_QUIZ_Q2_MILD_ANSWER_3},
                        {id: '2_4', titleStrCode: strCode.CLUB_GRAND_FINALE_QUIZ_Q2_MILD_ANSWER_4, isCorrect: true},
                    ],
                },
                [userSegmentTypes.SPRINT]: {
                    titleStrCode: strCode.CLUB_GRAND_FINALE_QUIZ_SLIDE_2_SPRINT_TITLE,
                    options: [
                        {id: '2_1', titleStrCode: strCode.CLUB_GRAND_FINALE_QUIZ_Q2_SPRINT_ANSWER_1},
                        {id: '2_2', titleStrCode: strCode.CLUB_GRAND_FINALE_QUIZ_Q2_SPRINT_ANSWER_2},
                        {id: '2_3', titleStrCode: strCode.CLUB_GRAND_FINALE_QUIZ_Q2_SPRINT_ANSWER_3, isCorrect: true},
                        {id: '2_4', titleStrCode: strCode.CLUB_GRAND_FINALE_QUIZ_Q2_SPRINT_ANSWER_4},
                    ],
                },
                [userSegmentTypes.CHILLED]: {
                    titleStrCode: strCode.CLUB_GRAND_FINALE_QUIZ_SLIDE_2_CHILLED_TITLE,
                    options: [
                        {id: '2_1', titleStrCode: strCode.CLUB_GRAND_FINALE_QUIZ_Q2_CHILLED_ANSWER_1, isCorrect: true},
                        {id: '2_2', titleStrCode: strCode.CLUB_GRAND_FINALE_QUIZ_Q2_CHILLED_ANSWER_2},
                        {id: '2_3', titleStrCode: strCode.CLUB_GRAND_FINALE_QUIZ_Q2_CHILLED_ANSWER_3},
                        {id: '2_4', titleStrCode: strCode.CLUB_GRAND_FINALE_QUIZ_Q2_CHILLED_ANSWER_4},
                    ],
                },
                [userSegmentTypes.ALLERT]: {
                    titleStrCode: strCode.CLUB_GRAND_FINALE_QUIZ_SLIDE_2_ALLERT_TITLE,
                    options: [
                        {id: '2_1', titleStrCode: strCode.CLUB_GRAND_FINALE_QUIZ_Q2_ALLERT_ANSWER_1, isCorrect: true},
                        {id: '2_2', titleStrCode: strCode.CLUB_GRAND_FINALE_QUIZ_Q2_ALLERT_ANSWER_2},
                        {id: '2_3', titleStrCode: strCode.CLUB_GRAND_FINALE_QUIZ_Q2_ALLERT_ANSWER_3},
                        {id: '2_4', titleStrCode: strCode.CLUB_GRAND_FINALE_QUIZ_Q2_ALLERT_ANSWER_4},
                    ],
                },
            },
            {
                id: 3,
                titleStrCode: strCode.CLUB_GRAND_FINALE_QUIZ_SLIDE_3_REGULAR_TITLE,
                options: [
                    {id: '3_1', titleStrCode: strCode.CLUB_GRAND_FINALE_QUIZ_Q3_REGULAR_ANSWER_1},
                    {id: '3_2', titleStrCode: strCode.CLUB_GRAND_FINALE_QUIZ_Q3_REGULAR_ANSWER_2, isCorrect: true},
                    {id: '3_3', titleStrCode: strCode.CLUB_GRAND_FINALE_QUIZ_Q3_REGULAR_ANSWER_3},
                    {id: '3_4', titleStrCode: strCode.CLUB_GRAND_FINALE_QUIZ_Q3_REGULAR_ANSWER_4},
                ],
                [userSegmentTypes.MILD]: {
                    titleStrCode: strCode.CLUB_GRAND_FINALE_QUIZ_SLIDE_3_MILD_TITLE,
                    options: [
                        {id: '3_1', titleStrCode: strCode.CLUB_GRAND_FINALE_QUIZ_Q3_MILD_ANSWER_1},
                        {id: '3_2', titleStrCode: strCode.CLUB_GRAND_FINALE_QUIZ_Q3_MILD_ANSWER_2},
                        {id: '3_3', titleStrCode: strCode.CLUB_GRAND_FINALE_QUIZ_Q3_MILD_ANSWER_3, isCorrect: true},
                        {id: '3_4', titleStrCode: strCode.CLUB_GRAND_FINALE_QUIZ_Q3_MILD_ANSWER_4},
                    ],
                },
                [userSegmentTypes.SPRINT]: {
                    titleStrCode: strCode.CLUB_GRAND_FINALE_QUIZ_SLIDE_3_SPRINT_TITLE,
                    options: [
                        {id: '3_1', titleStrCode: strCode.CLUB_GRAND_FINALE_QUIZ_Q3_SPRINT_ANSWER_1, isCorrect: true},
                        {id: '3_2', titleStrCode: strCode.CLUB_GRAND_FINALE_QUIZ_Q3_SPRINT_ANSWER_2},
                        {id: '3_3', titleStrCode: strCode.CLUB_GRAND_FINALE_QUIZ_Q3_SPRINT_ANSWER_3},
                        {id: '3_4', titleStrCode: strCode.CLUB_GRAND_FINALE_QUIZ_Q3_SPRINT_ANSWER_4},
                    ],
                },
                [userSegmentTypes.CHILLED]: {
                    titleStrCode: strCode.CLUB_GRAND_FINALE_QUIZ_SLIDE_3_CHILLED_TITLE,
                    options: [
                        {id: '3_1', titleStrCode: strCode.CLUB_GRAND_FINALE_QUIZ_Q3_CHILLED_ANSWER_1, isCorrect: true},
                        {id: '3_2', titleStrCode: strCode.CLUB_GRAND_FINALE_QUIZ_Q3_CHILLED_ANSWER_2},
                        {id: '3_3', titleStrCode: strCode.CLUB_GRAND_FINALE_QUIZ_Q3_CHILLED_ANSWER_3},
                        {id: '3_4', titleStrCode: strCode.CLUB_GRAND_FINALE_QUIZ_Q3_CHILLED_ANSWER_4},
                    ],
                },
                [userSegmentTypes.ALLERT]: {
                    titleStrCode: strCode.CLUB_GRAND_FINALE_QUIZ_SLIDE_3_ALLERT_TITLE,
                    options: [
                        {id: '3_1', titleStrCode: strCode.CLUB_GRAND_FINALE_QUIZ_Q3_ALLERT_ANSWER_1},
                        {id: '3_2', titleStrCode: strCode.CLUB_GRAND_FINALE_QUIZ_Q3_ALLERT_ANSWER_2},
                        {id: '3_3', titleStrCode: strCode.CLUB_GRAND_FINALE_QUIZ_Q3_ALLERT_ANSWER_3, isCorrect: true},
                        {id: '3_4', titleStrCode: strCode.CLUB_GRAND_FINALE_QUIZ_Q3_ALLERT_ANSWER_4},
                    ],
                },
            },
            {
                id: 4,
                titleStrCode: strCode.CLUB_GRAND_FINALE_QUIZ_SLIDE_4_REGULAR_TITLE,
                options: [
                    {id: '4_1', titleStrCode: strCode.CLUB_GRAND_FINALE_QUIZ_Q4_REGULAR_ANSWER_1, isCorrect: true},
                    {id: '4_2', titleStrCode: strCode.CLUB_GRAND_FINALE_QUIZ_Q4_REGULAR_ANSWER_2},
                    {id: '4_3', titleStrCode: strCode.CLUB_GRAND_FINALE_QUIZ_Q4_REGULAR_ANSWER_3},
                    {id: '4_4', titleStrCode: strCode.CLUB_GRAND_FINALE_QUIZ_Q4_REGULAR_ANSWER_4},
                ],
                [userSegmentTypes.MILD]: {
                    titleStrCode: strCode.CLUB_GRAND_FINALE_QUIZ_SLIDE_4_MILD_TITLE,
                    options: [
                        {id: '4_1', titleStrCode: strCode.CLUB_GRAND_FINALE_QUIZ_Q4_MILD_ANSWER_1},
                        {id: '4_2', titleStrCode: strCode.CLUB_GRAND_FINALE_QUIZ_Q4_MILD_ANSWER_2},
                        {id: '4_3', titleStrCode: strCode.CLUB_GRAND_FINALE_QUIZ_Q4_MILD_ANSWER_3},
                        {id: '4_4', titleStrCode: strCode.CLUB_GRAND_FINALE_QUIZ_Q4_MILD_ANSWER_4, isCorrect: true},
                    ],
                },
                [userSegmentTypes.SPRINT]: {
                    titleStrCode: strCode.CLUB_GRAND_FINALE_QUIZ_SLIDE_4_SPRINT_TITLE,
                    options: [
                        {id: '4_1', titleStrCode: strCode.CLUB_GRAND_FINALE_QUIZ_Q4_SPRINT_ANSWER_1},
                        {id: '4_2', titleStrCode: strCode.CLUB_GRAND_FINALE_QUIZ_Q4_SPRINT_ANSWER_2},
                        {id: '4_3', titleStrCode: strCode.CLUB_GRAND_FINALE_QUIZ_Q4_SPRINT_ANSWER_3},
                        {id: '4_4', titleStrCode: strCode.CLUB_GRAND_FINALE_QUIZ_Q4_SPRINT_ANSWER_4, isCorrect: true},
                    ],
                },
                [userSegmentTypes.CHILLED]: {
                    titleStrCode: strCode.CLUB_GRAND_FINALE_QUIZ_SLIDE_4_CHILLED_TITLE,
                    options: [
                        {id: '4_1', titleStrCode: strCode.CLUB_GRAND_FINALE_QUIZ_Q4_CHILLED_ANSWER_1, isCorrect: true},
                        {id: '4_2', titleStrCode: strCode.CLUB_GRAND_FINALE_QUIZ_Q4_CHILLED_ANSWER_2},
                        {id: '4_3', titleStrCode: strCode.CLUB_GRAND_FINALE_QUIZ_Q4_CHILLED_ANSWER_3},
                        {id: '4_4', titleStrCode: strCode.CLUB_GRAND_FINALE_QUIZ_Q4_CHILLED_ANSWER_4},
                    ],
                },
                [userSegmentTypes.ALLERT]: {
                    titleStrCode: strCode.CLUB_GRAND_FINALE_QUIZ_SLIDE_4_ALLERT_TITLE,
                    options: [
                        {id: '4_1', titleStrCode: strCode.CLUB_GRAND_FINALE_QUIZ_Q4_ALLERT_ANSWER_1},
                        {id: '4_2', titleStrCode: strCode.CLUB_GRAND_FINALE_QUIZ_Q4_ALLERT_ANSWER_2},
                        {id: '4_3', titleStrCode: strCode.CLUB_GRAND_FINALE_QUIZ_Q4_ALLERT_ANSWER_3},
                        {id: '4_4', titleStrCode: strCode.CLUB_GRAND_FINALE_QUIZ_Q4_ALLERT_ANSWER_4, isCorrect: true},
                    ],
                },
            },
            {
                id: 5,
                titleStrCode: strCode.CLUB_GRAND_FINALE_QUIZ_SLIDE_5_TITLE,
                options: [
                    {id: '5_1', titleStrCode: strCode.CLUB_GRAND_FINALE_QUIZ_Q5_ANSWER_1},
                    {id: '5_2', titleStrCode: strCode.CLUB_GRAND_FINALE_QUIZ_Q5_ANSWER_2},
                    {id: '5_3', titleStrCode: strCode.CLUB_GRAND_FINALE_QUIZ_Q5_ANSWER_3},
                    {id: '5_4', titleStrCode: strCode.CLUB_GRAND_FINALE_QUIZ_Q5_ANSWER_4, isCorrect: true},
                ],
            },
        ],
        completedSlide: {
            titleStrCode: strCode.CLUB_GRAND_FINALE_QUIZ_COMPLETE_TITLE,
            buttonStrCode: strCode.CLUB_GRAND_FINALE_QUIZ_COMPLETE_BUTTON,
            milestoneTitleStrCode: strCode.CLUB_GRAND_FINALE_QUIZ_COMPLETE_MILESTONE_TITLE,
            onClick: () => dispatch(hideAllModals()),
        },
    },
    [quizTypes.HOW_TO_USE_QUIZ]: {
        titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_11_QUIZ_TITLE,
        descriptionStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_11_QUIZ_DESCRIPTION,
        buttonStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_11_QUIZ_START_BUTTON,
        badge: badgeTypes.SWITCH_MASTER,
        startIcon: AlwaysReadyIcon,
        startBackground: GRAND_FINALE_QUIZ_BACKGROUND_IMAGE,
        milestoneType: milestoneTypes.SWITCH_11,
        skipStartScreen: true,
        showValidation: true,
        slides: [
            {
                id: 1,
                titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_11_QUIZ_Q1,
                options: [
                    {id: '1_1', titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_11_QUIZ_Q1_ANSWER_1, isCorrect: true},
                    {id: '1_2', titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_11_QUIZ_Q1_ANSWER_2},
                    {id: '1_3', titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_11_QUIZ_Q1_ANSWER_3},
                    {id: '1_4', titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_11_QUIZ_Q1_ANSWER_4},
                ],
            },
            {
                id: 2,
                titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_11_QUIZ_Q2,
                options: [
                    {id: '2_1', titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_11_QUIZ_Q2_ANSWER_1},
                    {id: '2_2', titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_11_QUIZ_Q2_ANSWER_2},
                    {id: '2_3', titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_11_QUIZ_Q2_ANSWER_3, isCorrect: true},
                    {id: '2_4', titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_11_QUIZ_Q2_ANSWER_4},
                ],
            },
        ],
        completedSlide: {
            titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_11_QUIZ_COMPLETED_TITLE,
            buttonStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_11_QUIZ_COMPLETED_DECLINE_BTN,
            onClick: (navigate) => {
                navigate({
                    route: routerService.getPersonaliseRoute(),
                    milestoneType: milestoneTypes.SWITCH_11,
                });
            },
            onDeclineClick: () => {
                dispatch(hideAllModals());
            },
        },
    },
    [quizTypes.TASTE_DISCOVERY_QUIZ]: {
        descriptionStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_13_QUIZ_DESCRIPTION,
        buttonStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_13_QUIZ_START_BUTTON,
        titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_13_CC_QUIZ_TITLE,
        startBackground: GRAND_FINALE_QUIZ_BACKGROUND_IMAGE,
        milestoneType: milestoneTypes.SWITCH_13,
        badge: badgeTypes.SWITCH_MASTER,
        startIcon: ContestsIcon,
        showValidation: true,
        skipStartScreen: true,
        [userSegmentTypes.EVAPE_DUAL]: {
            titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_13_EVAPE_QUIZ_TITLE,
        },
        [userSegmentTypes.COMP_HNB]: {
            titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_13_COMP_QUIZ_TITLE,
        },
        slides: [
            {
                id: 0,
                type: quizQuestionTypes.FILL_BLANKS,
                titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_13_QUIZ_COMPLETE_SENTENCE,
                questionStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_13_COMP_QUIZ_Q1,
                blanks: [
                    {
                        id: 'blank1_1',
                        correctOptionId: '1_2',
                        placeholderStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_13_COMP_QUIZ_Q1_ANSWER_2,
                    },
                ],
                options: [
                    {
                        id: '1_1',
                        titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_13_COMP_QUIZ_Q1_ANSWER_1,
                    },
                    {
                        id: '1_2',
                        titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_13_COMP_QUIZ_Q1_ANSWER_2,
                        blankId: 'blank1_1',
                        isCorrect: true,
                    },
                    {
                        id: '1_3',
                        titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_13_COMP_QUIZ_Q1_ANSWER_3,
                    },
                ],
                [userSegmentTypes.EVAPE_DUAL]: {
                    questionStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_13_EVAPE_QUIZ_Q1,
                    blanks: [
                        {
                            id: 'blank1_1',
                            correctOptionId: '1_1',
                            placeholderStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_13_EVAPE_QUIZ_Q1_ANSWER_1,
                        },
                    ],
                    options: [
                        {
                            id: '1_1',
                            titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_13_EVAPE_QUIZ_Q1_ANSWER_1,
                            blankId: 'blank1_1',
                            isCorrect: true,
                        },
                        {
                            id: '1_2',
                            titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_13_EVAPE_QUIZ_Q1_ANSWER_2,
                        },
                    ],
                },
                [userSegmentTypes.COMP_HNB]: {
                    questionStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_13_COMP_QUIZ_Q1,
                    blanks: [
                        {
                            id: 'blank1_1',
                            correctOptionId: '1_2',
                            placeholderStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_13_COMP_QUIZ_Q1_ANSWER_2,
                        },
                    ],
                    options: [
                        {
                            id: '1_1',
                            titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_13_COMP_QUIZ_Q1_ANSWER_1,
                        },
                        {
                            id: '1_2',
                            titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_13_COMP_QUIZ_Q1_ANSWER_2,
                            blankId: 'blank1_1',
                            isCorrect: true,
                        },
                        {
                            id: '1_3',
                            titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_13_COMP_QUIZ_Q1_ANSWER_3,
                        },
                    ],
                },
            },
            {
                id: 1,
                type: quizQuestionTypes.FILL_BLANKS,
                titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_13_QUIZ_COMPLETE_SENTENCE,
                questionStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_13_COMP_QUIZ_Q2,
                blanks: [
                    {
                        id: 'blank2_1',
                        placeholderStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_13_COMP_QUIZ_Q2_ANSWER_1,
                    },
                    {
                        id: 'blank2_2',
                        placeholderStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_13_COMP_QUIZ_Q2_ANSWER_2,
                    },
                ],
                options: [
                    {
                        id: '2_1',
                        titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_13_COMP_QUIZ_Q2_ANSWER_1,
                        isCorrect: true,
                    },
                    {
                        id: '2_2',
                        titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_13_COMP_QUIZ_Q2_ANSWER_2,
                        isCorrect: true,
                    },
                    {
                        id: '2_3',
                        titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_13_COMP_QUIZ_Q2_ANSWER_3,
                    },
                    {
                        id: '2_4',
                        titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_13_COMP_QUIZ_Q2_ANSWER_4,
                    },
                ],
                [userSegmentTypes.EVAPE_DUAL]: {
                    questionStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_13_EVAPE_QUIZ_Q2,
                    blanks: [
                        {
                            id: 'blank2_1',
                            correctOptionId: '2_1',
                            placeholderStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_13_EVAPE_QUIZ_Q2_ANSWER_1,
                        },
                    ],
                    options: [
                        {
                            id: '2_1',
                            titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_13_EVAPE_QUIZ_Q2_ANSWER_1,
                            blankId: 'blank2_1',
                            isCorrect: true,
                        },
                        {
                            id: '2_2',
                            titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_13_EVAPE_QUIZ_Q2_ANSWER_2,
                        },
                        {
                            id: '2_3',
                            titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_13_EVAPE_QUIZ_Q2_ANSWER_3,
                        },
                        {
                            id: '2_4',
                            titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_13_EVAPE_QUIZ_Q2_ANSWER_4,
                        },
                    ],
                },
                [userSegmentTypes.COMP_HNB]: {
                    questionStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_13_COMP_QUIZ_Q2,
                    blanks: [
                        {
                            id: 'blank2_1',
                            placeholderStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_13_COMP_QUIZ_Q2_ANSWER_1,
                        },
                        {
                            id: 'blank2_2',
                            placeholderStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_13_COMP_QUIZ_Q2_ANSWER_2,
                        },
                    ],
                    options: [
                        {
                            id: '2_1',
                            titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_13_COMP_QUIZ_Q2_ANSWER_1,
                            isCorrect: true,
                        },
                        {
                            id: '2_2',
                            titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_13_COMP_QUIZ_Q2_ANSWER_2,
                            isCorrect: true,
                        },
                        {
                            id: '2_3',
                            titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_13_COMP_QUIZ_Q2_ANSWER_3,
                        },
                        {
                            id: '2_4',
                            titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_13_COMP_QUIZ_Q2_ANSWER_4,
                        },
                    ],
                },
            },
            {
                id: 2,
                type: quizQuestionTypes.FILL_BLANKS,
                titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_13_QUIZ_COMPLETE_SENTENCE,
                questionStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_13_COMP_QUIZ_Q3,
                blanks: [
                    {
                        id: 'blank3_1',
                        correctOptionId: '3_2',
                        placeholderStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_13_COMP_QUIZ_Q3_ANSWER_2,
                    },
                ],
                options: [
                    {
                        id: '3_1',
                        titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_13_COMP_QUIZ_Q3_ANSWER_1,
                    },
                    {
                        id: '3_2',
                        titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_13_COMP_QUIZ_Q3_ANSWER_2,
                        blankId: 'blank3_1',
                        isCorrect: true,
                    },
                    {
                        id: '3_3',
                        titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_13_COMP_QUIZ_Q3_ANSWER_3,
                    },
                ],
                [userSegmentTypes.EVAPE_DUAL]: {
                    questionStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_13_EVAPE_QUIZ_Q3,
                    blanks: [
                        {
                            id: 'blank3_1',
                            correctOptionId: '3_4',
                            placeholderStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_13_EVAPE_QUIZ_Q3_ANSWER_4,
                        },
                    ],
                    options: [
                        {
                            id: '3_1',
                            titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_13_EVAPE_QUIZ_Q3_ANSWER_1,
                        },
                        {
                            id: '3_2',
                            titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_13_EVAPE_QUIZ_Q3_ANSWER_2,
                        },
                        {
                            id: '3_3',
                            titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_13_EVAPE_QUIZ_Q3_ANSWER_3,
                        },
                        {
                            id: '3_4',
                            titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_13_EVAPE_QUIZ_Q3_ANSWER_4,
                            blankId: 'blank3_1',
                            isCorrect: true,
                        },
                    ],
                },
                [userSegmentTypes.COMP_HNB]: {
                    questionStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_13_COMP_QUIZ_Q3,
                    blanks: [
                        {
                            id: 'blank3_1',
                            correctOptionId: '3_2',
                            placeholderStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_13_COMP_QUIZ_Q3_ANSWER_2,
                        },
                    ],
                    options: [
                        {
                            id: '3_1',
                            titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_13_COMP_QUIZ_Q3_ANSWER_1,
                        },
                        {
                            id: '3_2',
                            titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_13_COMP_QUIZ_Q3_ANSWER_2,
                            blankId: 'blank3_1',
                            isCorrect: true,
                        },
                        {
                            id: '3_3',
                            titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_13_COMP_QUIZ_Q3_ANSWER_3,
                        },
                    ],
                },
            },
        ],
        completedSlide: {
            titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_13_COMP_QUIZ_TITLE,
            buttonStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_13_QUIZ_SEE_PROGRESS_BTN,
            secondButtonStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_13_QUIZ_SEE_PROGRESS_SECOND_BTN,
            onClick: () => {
                dispatch(hideAllModals());
            },
            onSecondClick: () => {
                dispatch(showStoresModal());
            },
            onDeclineClick: () => {
                dispatch(hideAllModals());
            },
        },
    },
    [quizTypes.MOTIVATION_QUIZ]: {
        milestoneType: milestoneTypes.SWITCH_23,
        badge: badgeTypes.SWITCH_MASTER,
        showValidation: true,
        skipStartScreen: true,
        slides: [
            {
                id: 1,
                titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_23_QUIZ_SLIDE_1_TITLE,
                subTitleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_23_QUIZ_SLIDE_1_SUBTITLE,
                options: [
                    {
                        id: '1_1',
                        titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_23_QUIZ_SLIDE_1_ANSWER_1,
                    },
                    {
                        id: '1_2',
                        titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_23_QUIZ_SLIDE_1_ANSWER_2,
                        isCorrect: true,
                    },
                ],
            },
            {
                id: 2,
                titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_23_QUIZ_SLIDE_2_TITLE,
                subTitleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_23_QUIZ_SLIDE_2_SUBTITLE,
                options: [
                    {
                        id: '2_1',
                        titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_23_QUIZ_SLIDE_2_ANSWER_1,
                        isCorrect: true,
                    },
                    {
                        id: '2_2',
                        titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_23_QUIZ_SLIDE_2_ANSWER_2,
                    },
                ],
            },
            {
                id: 3,
                titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_23_QUIZ_SLIDE_3_TITLE,
                subTitleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_23_QUIZ_SLIDE_3_SUBTITLE,
                options: [
                    {
                        id: '3_1',
                        titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_23_QUIZ_SLIDE_3_ANSWER_1,
                    },
                    {
                        id: '3_2',
                        titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_23_QUIZ_SLIDE_3_ANSWER_2,
                        isCorrect: true,
                    },
                ],
            },
        ],
        completedSlide: {
            titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_23_COMP_QUIZ_TITLE,
            buttonStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_23_QUIZ_COMP_BTN,
            secondButtonStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_23_QUIZ_STORE_BTN,
            onClick: () => {
                dispatch(hideAllModals());
            },
            onSecondClick: () => {
                dispatch(showStoresModal());
            },
            onDeclineClick: () => {
                dispatch(hideAllModals());
            },
        },
    },
};

export default CLUB_QUIZ_CONFIG;
